const EXPANDABLE_INPUT_INIT_OFFSET = 85;
function resolveChatContentHeight(args) {
    const { isDialogStylesEmpty, expandableTextHeight } = args;
    const heightOffset = EXPANDABLE_INPUT_INIT_OFFSET + expandableTextHeight;
    if (!isDialogStylesEmpty) return `calc(100% - ${heightOffset}px)`;
    return 'calc(100% - 120px)';
}
function resolveChatContentStyle(args) {
    const { isDialogStylesEmpty, dialogStyles, standaloneStyles } = args;
    return isDialogStylesEmpty ? standaloneStyles : dialogStyles;
}
export { resolveChatContentHeight, resolveChatContentStyle };
